import { useLoader } from '@react-three/fiber';
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader.js';
import { MTLLoader } from 'three/examples/jsm/loaders/MTLLoader.js';
import { TextureLoader } from 'three';

export default function CampfireModel({
  url = '/objs/campfire/Campfire.obj',
  mtlUrl = '/objs/campfire/Campfire.mtl',
  position = [0, 0, 0],
  scale = 1,
}) {
  const materials = useLoader(MTLLoader, mtlUrl);
  materials.preload();

  const obj = useLoader(OBJLoader, url, loader => {
    loader.setMaterials(materials);
  });


  // Manually load the texture
  const texture = useLoader(TextureLoader, '/objs/campfire/Campfire_fire_MAT_BaseColor.jpg');

  obj.traverse(child => {
    if (child.isMesh) {
      // Assign the texture if not present
      if (!child.material.map) {
        child.material.map = texture;
        child.material.needsUpdate = true;
      }
      child.castShadow = true;
      child.receiveShadow = true;
    }
  });


  return (
    <primitive
      object={obj}
      position={position}
      scale={scale}
      castShadow
      receiveShadow
    />
  );
}